import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'rxjs';
import { LsnErrorStateMatcher } from '../error-state-matcher';


export const CUSTOM_CHECKBOX_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CheckboxComponent),
    multi: true
};

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    providers: [CUSTOM_CHECKBOX_CONTROL_VALUE_ACCESSOR]
})
export class CheckboxComponent implements ControlValueAccessor {
    @Input() floatLabel: string;
    @Input() errorStateMatcher: LsnErrorStateMatcher;
    @Input() label: string;
    @Input() disabled = false;
    @Output() onBlur = new EventEmitter();

    value: boolean = null;

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    onBlurAction() {
        this.onBlur.emit();
    }

    writeValue(value: any) {
        this.value = value;
        this.onChangeCallback(value);
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
}
